import { appLayoutContentId } from '@amzn/meridian/app-layout';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// This component just keeps track of page navigation
// On page navigation, we trigger a manual reset of the y-scroll position.
export const ResetScroll = () => {
    const { pathname } = useLocation();

    // If the pathname value returned from useLocation() changes,
    // manually ensure that that page is at 0,0 scroll position
    useEffect(() => {
        const appContent = document.getElementById(appLayoutContentId);
        if (appContent) {
            appContent.scrollTop = 0;
            appContent.scrollLeft = 0;
        }
    }, [pathname]);

    return null;
};
